import { MinedInsightTextItem } from "../../types";

/** Visual variant for a historical insight section. */
export type InsightSectionVariant = "neutral" | "danger" | "warning";

/**
 * Props for a historical insight section card.
 */
export interface InsightSectionProps {
  /** Uppercase section heading (e.g. DRUG PLAN RULE). */
  title: string;
  /** Insight text items to render as a numbered list. */
  items: MinedInsightTextItem[];
  /** Color variant; danger is reddish, warning is yellowish. */
  variant?: InsightSectionVariant;
}

/**
 * Returns heading/number text color classes for a section variant.
 *
 * @param variant - Section color variant
 * @returns Tailwind class string for accent text
 */
export const getInsightAccentTextClass = (
  variant: InsightSectionVariant = "neutral",
): string => {
  switch (variant) {
    case "danger":
      return "text-tertiaryRed-3";
    case "warning":
      return "text-secondaryOrange-2";
    case "neutral":
    default:
      return "text-primaryGray-6";
  }
};

/**
 * Returns item card background classes for a section variant.
 *
 * @param variant - Section color variant
 * @returns Tailwind class string for card background
 */
export const getInsightCardBgClass = (
  variant: InsightSectionVariant = "neutral",
): string => {
  switch (variant) {
    case "danger":
      return "bg-[#FFF8F8]";
    case "warning":
      return "bg-[#FFFBF0]";
    case "neutral":
    default:
      return "bg-primaryGray-16";
  }
};
